import * as batchType from './_batch-type';
import * as businessRule from './_business-rule';
import * as common from './_common';
import * as documentType from './_document-type';
import * as namingRule from './_naming-rule';

/** BatchTypeLibrary logic. */
const batchTypeLogic = {
  ...common,
  batchType,
  documentType,
  namingRule,
  businessRule,
};

export type { BatchTypeComponent, BatchTypePatternTabKey, DocumentTypeComponent, DocumentTypePatternTabKey } from './_common.type';

export default batchTypeLogic;
